import React from "react";
import {
  Container,
  Grid,
  Typography,
  Box,
  MenuList,
  MenuItem
} from "@material-ui/core";
import MuiLink from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/styles";
import PhoneIcon from "@material-ui/icons/Phone";
import clsx from "clsx";
import { Link } from "react-router-dom";
import StHtml from "./shared/StHtml";
import useScreensize from "../hooks/useScreensize";

const useStyles = makeStyles(theme => ({
  footer: {
    padding: theme.spacing(4, 0),
    marginTop: "auto",
    backgroundColor: theme.palette.primary.main,
    position: "relative",
    zIndex: 2,
    color: "white"
  },
  footerLinks: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("sm")]: {
      alignItems: "flex-end",
      justifyContent: "center"
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(2)
    }
  },
  footerLink: {
    margin: theme.spacing(1, 0),
    color: "white",
    [theme.breakpoints.up("sm")]: {
      margin: theme.spacing(2)
    }
  },
  phoneIcon: {
    marginRight: theme.spacing(1),
    width: 24,
    height: 24
  },
  title: {
    opacity: 0.7,
    marginBottom: theme.spacing(2)
  },
  menuItem: {
    height: 30,
    minHeight: 30,
    fontSize: "1rem"
  }
}));

const Footer = ({ settings }) => {
  const classes = useStyles();

  const footerMenu = (
    <MenuList dense>
      {[
        { title: "Impressum", url: "/impressum" },
        { title: "Datenschutzerklärung", url: "/datenschutz" }
      ].map((item, index) => (
        <MenuItem
          className={clsx(classes.menuItem)}
          button
          key={index}
          component={Link}
          to={item.url}
        >
          {item.title}
        </MenuItem>
      ))}
    </MenuList>
  );

  const footerSecondaryMenu = (
    <MenuList dense>
      {[
        { title: "Stadtgarde Trier", url: "http://www.stadtgarde-trier.de/" }
      ].map((item, index) => (
        <MenuItem
          className={clsx(classes.menuItem)}
          button
          key={index}
          component="a"
          href={item.url}
          target="_blank"
        >
          {item.title}
        </MenuItem>
      ))}
    </MenuList>
  );

  return (
    <>
      <footer className={classes.footer}>
        <Container maxWidth="lg">
          <Grid container>
            <Grid item xs={12} sm={6} lg={3}>
              <Box mt={{ xs: 4, lg: 0 }}>
                <Typography variant="h6" className={classes.title}>
                  Rechtliches:
                </Typography>
                <Box ml={-2} mt={-1.5} pr={3}>
                  {footerMenu}
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              <Box mt={{ xs: 4, lg: 0 }}>
                <Typography variant="h6" className={classes.title}>
                  Besuchen Sie auch:
                </Typography>
                <Box ml={-2} mt={-1.5} pr={3}>
                  {footerSecondaryMenu}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </footer>
    </>
  );
};

export default Footer;
